import nbNO from "./locales/nbNO"
import enGB from "./locales/enGB"
import deDE from "./locales/deDE"
import esES from "./locales/esES"
import frFR from "./locales/frFR"
import itIT from "./locales/itIT"
import jpJP from "./locales/jpJP"
import nlBE from "./locales/nlBE"
import nlNL from "./locales/nlNL"
import svSE from "./locales/svSE"
import daDK from "./locales/daDK"
import fiFI from "./locales/fiFI"
import ptPT from "./locales/ptPT"

export const locale = {
  defaultLanguage: "en-GB",
  language: "en-GB",

  get: function (language?: string) {
    const currentLanguage = language || this.language

    // Get exact locale, like nl-BE.
    const exactLocale = locale[currentLanguage]
    if (exactLocale) {
      return exactLocale
    }

    // Get locale for only language code, like nl.
    const shortLanguageCode = currentLanguage.substr(0, 2)
    const defaultLocale = locale[shortLanguageCode]
    if (defaultLocale) {
      return defaultLocale
    }

    return locale[this.defaultLanguage]
  },

  // Exact locales.
  "en-GB": enGB,
  "nb-NO": nbNO,
  "de-DE": deDE,
  "es-ES": esES,
  "fr-FR": frFR,
  "it-IT": itIT,
  "jp-JP": jpJP,
  "nl-BE": nlBE,
  "nl-NL": nlNL,
  "sv-SE": svSE,
  "da-DK": daDK,
  "fi-FI": fiFI,
  "pt-PT": ptPT,

  // Default locales.
  en: enGB,
  nb: nbNO,
  de: deDE,
  es: esES,
  fr: frFR,
  it: itIT,
  jp: jpJP,
  nl: nlNL,
  sv: svSE,
  da: daDK,
  fi: fiFI,
  pt: ptPT
}
